export const enum FilterOperators {
  StringEqual = 'StringEqual',
  Equal = 'Equal',
  Contains = 'Contains',
  StartsWith = 'StartsWith',
  DateLessThanOrEqual = 'DateLessThanOrEqual',
  DateGreaterThanOrEqual = 'DateGreaterThanOrEqual',
  NumberContains = 'NumberContains',
  NestedEqual = 'NestedEqual',
  DateEqual = 'DateEqual',
  Custom = 'Custom'
}
